new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

const fixAccessibility = () => {
    document.querySelectorAll('.swatch-image').forEach(el => {
        if (!el.hasAttribute('alt')) {
            const tooltip = el.parentElement.parentElement.querySelector('.gpo-tooltip')
            console.log(tooltip)
            if (tooltip) {
                const span = tooltip.querySelector('span');
                console.log(span)
                if (span) {
                    const text = span.innerText;
                    el.setAttribute('alt', text);
                }
            }
        }
    })

    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })
}

fixAccessibility();
